'use client';
import React from 'react';
import Image from 'next/image';
import image1 from '../../../Assets/Skills-logo/_shopping-512.webp';
import image2 from '../../../Assets/Skills-logo/Ant-Design-Templates.webp';
import image3 from '../../../Assets/Skills-logo/axios.svg';
import image4 from '../../../Assets/Skills-logo/blog-mui.png';
import image5 from '../../../Assets/Skills-logo/Bootstrap_logo.svg.png';
import image6 from '../../../Assets/Skills-logo/C++_logo.png';
import image7 from '../../../Assets/Skills-logo/C_Programming.png';
import image8 from '../../../Assets/Skills-logo/canva-icon.webp';
import image9 from '../../../Assets/Skills-logo/css.webp';
import image10 from '../../../Assets/Skills-logo/django-logo-positive.png';
import image11 from '../../../Assets/Skills-logo/Express.png';
import image12 from '../../../Assets/Skills-logo/Firebase-logo-02.png';
import image13 from '../../../Assets/Skills-logo/GitHub-Logo.png';
import image14 from '../../../Assets/Skills-logo/html.webp';
import image15 from '../../../Assets/Skills-logo/shadcn-ui-logo.png';
import image16 from '../../../Assets/Skills-logo/JavaScript-logo.png';
import image17 from '../../../Assets/Skills-logo/kinemaster-logo-transparent.png';
import image18 from '../../../Assets/Skills-logo/Logo_PostgreSQL.png';
import image19 from '../../../Assets/Skills-logo/mongodb.png';
import image20 from '../../../Assets/Skills-logo/nextjs-2.png';
import image21 from '../../../Assets/Skills-logo/python.webp';
import image22 from '../../../Assets/Skills-logo/React.webp';
import image23 from '../../../Assets/Skills-logo/redux-icon.png';
import image24 from '../../../Assets/Skills-logo/Tailwind_CSS_Logo.svg.png';
import image25 from '../../../Assets/Skills-logo/react-query.png';
import image26 from '../../../Assets/Skills-logo/Typescript.png';
import image27 from '../../../Assets/Skills-logo/images (1).png';
import image28 from '../../../Assets/Skills-logo/openai-chatgpt-logo-icon-free-png.webp';
import TitleMain from '@/components/shared/TitleMain/TitleMain';
import { AnimatedTooltip } from '@/components/UI/animated-tooltip';
import { motion } from 'framer-motion';
const MySkills = () => {
  const categories = [
    {
      title: 'Programming Languages',
      skills: [
        { id: 1, name: 'C++', skill: { image: image6 } },
        { id: 2, name: 'C Programming', skill: { image: image7 } },
        { id: 3, name: 'Python', skill: { image: image21 } },
        { id: 4, name: 'JavaScript', skill: { image: image16 } },
        { id: 5, name: 'TypeScript', skill: { image: image26 } },
      ],
    },
    {
      title: 'Frontend Development',
      skills: [
        { id: 6, name: 'HTML', skill: { image: image14 } },
        { id: 7, name: 'CSS', skill: { image: image9 } },
        { id: 8, name: 'Tailwind CSS', skill: { image: image24 } },
        { id: 9, name: 'Bootstrap', skill: { image: image5 } },
        { id: 10, name: 'React.js', skill: { image: image22 } },
        { id: 11, name: 'Next.js', skill: { image: image20 } },
      ],
    },
    {
      title: 'Backend Development',
      skills: [
        // { id: 12, name: 'Django', skill: { image: image10 } },
        { id: 13, name: 'Express.js', skill: { image: image11 } },
        { id: 14, name: 'MongoDB', skill: { image: image19 } },
        { id: 15, name: 'PostgreSQL', skill: { image: image18 } },
        { id: 16, name: 'Firebase', skill: { image: image12 } },
      ],
    },
    {
      title: 'Tools & Libraries',
      skills: [
        { id: 17, name: 'Axios', skill: { image: image3 } },
        { id: 18, name: 'Redux Toolkit', skill: { image: image23 } },
        { id: 19, name: 'Tanstack Query', skill: { image: image25 } },
        { id: 20, name: 'Json Web Token', skill: { image: image27 } },
        { id: 21, name: 'GitHub', skill: { image: image13 } },
      ],
    },
    {
      title: 'Design & Other Tools',
      skills: [
        { id: 22, name: 'Canva', skill: { image: image8 } },
        { id: 23, name: 'KineMaster', skill: { image: image17 } },
        { id: 24, name: 'Shadcn UI', skill: { image: image15 } },
        { id: 25, name: 'Shopping', skill: { image: image1 } },
        { id: 26, name: 'OpenAI GPT', skill: { image: image28 } },
      ],
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 },
  };

  return (
    <div className='py-20 px-4 bg-gradient-to-b from-purple-800 via-blue-800 to-purple-800'>
      <div className='max-w-7xl mx-auto'>
        <TitleMain text={'Technical Arsenal'} />

        <motion.div
          initial='hidden'
          whileInView='visible'
          viewport={{ once: true, margin: '-100px' }}
          variants={containerVariants}
          className='space-y-16 mt-12'
        >
          {categories.map((category, index) => (
            <motion.div
              key={category.title}
              variants={containerVariants}
              className='group relative'
            >
              <div className='sticky top-24  backdrop-blur-sm py-4 z-10'>
                <h3 className='text-2xl font-bold text-purple-300 mb-4 text-center'>
                  {category.title}
                </h3>
              </div>

              <motion.div
                variants={containerVariants}
                className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 p-4 bg-white/5 rounded-xl border border-white/10'
              >
                {category.skills.map(skill => (
                  <motion.div
                    key={skill.id}
                    variants={itemVariants}
                    whileHover={{ scale: 1.05 }}
                    className='relative flex flex-col items-center p-4 bg-gradient-to-br from-black/30 to-purple-900/20 rounded-lg border border-white/10 hover:border-purple-400 transition-all'
                  >
                    <div className='relative w-16 h-16 mb-4'>
                      <Image
                        src={skill.skill.image}
                        alt={skill.name}
                        fill
                        className='object-contain hover:scale-110 transition-transform'
                        sizes='(max-width: 768px) 64px, 96px'
                      />
                    </div>
                    <span className='text-sm font-semibold text-center text-purple-100'>
                      {skill.name}
                    </span>
                    <div className='absolute inset-0 bg-gradient-to-t from-purple-500/10 to-transparent pointer-events-none' />
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default MySkills;
